import React, { useContext, useState } from "react";
import Input from "../input/Input";
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
import { UserContext } from '../../stores/Context/Context'
import validateInput from "../../utilities/validations/validateInput";
import { resetClaimSubmission, submitClaim } from "../../stores/slices/claimIntake/claimSubmissionSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from '../menu/Loader'
import { fetchClaimList, resetClaimList } from "../../stores/slices/claimIntake/claimListSlice";
import { getAllSessions } from "../../utilities/API/supertokenServices";

function Signature() {
  let contT = useContext(UserContext);
  const selectedLanguage = useSelector(language).Claimintake.signature;
  const errorMessage = useSelector(language).errorMessage
  const [signInfo, setSignInfo] = useState({
    esign: { value: "", isValid: true },
  })
  const loginData = useSelector(state => state.loginSlice.value)
  const userID = useSelector(state => state.loginSlice.userID)
  const claimIntakeData = useSelector(state => state.claimIntakeSlice)
  const claimProcessData = useSelector(state => state.claimProcessSlice)
  const ip = useSelector(state => state.preAuthSlice.ip)
  const isClaimSubmitted = useSelector((state => state.claimSubmissionSlice.isClaimSubmitted))
  const [isLoader, setIsLoader] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  if (isClaimSubmitted) {
    setIsLoader(false)
    dispatch(resetClaimSubmission())
    dispatch(resetClaimList())
    dispatch(fetchClaimList({ appID: undefined, ein: loginData.EIN, prgData: "CPR" }))
    dispatch(fetchClaimList({ appID: undefined, ein: loginData.EIN, prgData: "FAF" }))
    navigate("/createApp")
  }

  const inputOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);
    setSignInfo((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }))
  }


  function onSubmitClaim() {
    const today = new Date();
    const date = today.getFullYear() + String(today.getMonth() + 1).padStart(2, '0') + String(today.getDate()).padStart(2, '0')
    const reqBody = {
      "Expenditures": {
        "DefaultQueue": claimIntakeData.payableTo.payableTo.value != "Insurance" ? 'General POE' : "Direct Pay",
        "RouteTaskToWL": "false",
        "PortalUserID": loginData.PortalUserID,
        "SubmissionChannel": "Partner",
        "DocumentCategory": claimIntakeData.payableTo.payableTo.value != "Insurance" ? 'General' : "Direct Pay - Insurance",
        "DocumentReceptionDate": date,
        "DocumentSource": "Man",
        "ApplicationID": claimProcessData.applicationID,
        "ProviderID": `E-${loginData.EIN}`,
        "FundID": claimProcessData.fundID,
        "FundName": claimProcessData.fundName,
        "FundGroup": claimProcessData.fundGroup,
        "ESign": signInfo.esign.value,
        "ESignID": claimProcessData.email,
        "ESignIP": ip,
        "ESignType": "Partner",
        "ContactId": claimProcessData.contactID,
        "FundInsKey": `PAF-BEACON-WORK-FUNDS ${claimProcessData.fundID}`,
        "Files": claimIntakeData.claimDocumentsData,
        "RemitTo": {
          "IsNewProvider": false,
          "RemitToDescription": claimIntakeData.payableTo.payableTo.value,
          "PayableTo": claimIntakeData.payableTo.name.value,
          "IsInsurancePayor": claimIntakeData.payableTo.payableTo.value == "Insurance",
          "AddressVerified": "true",
          "AddressInfo": {
            "AddressLine1": claimIntakeData.payableTo.addressLine1.value,
            "AddressLine2": claimIntakeData.payableTo.addressLine2.value,
            "City": claimIntakeData.payableTo.city.value,
            "State": claimIntakeData.payableTo.state.value,
            "ZipCode": claimIntakeData.payableTo.zipCode.value,
            "Type": "Home",
            "FullAddressLine": `${claimIntakeData.payableTo.addressLine1.value + " " + claimIntakeData.payableTo.addressLine2.value}`,
            "FullAddressDesc": `${claimIntakeData.payableTo.addressLine1.value + " " + claimIntakeData.payableTo.addressLine2.value},${claimIntakeData.payableTo.city.value},${claimIntakeData.payableTo.state.value},${claimIntakeData.payableTo.zipCode.value}`,
          },
          "PatientName": claimProcessData.patientDetails.fullName
        },
        "LineItems": []
      },
      "ContactId": claimProcessData.contactID,
      "PortalUserID": loginData.PortalUserID,
      "ApplicationID": claimProcessData.applicationID,
      "SubmissionChannel": "Partner",
      "PortalUserDetails": {
        "EmailAddress": loginData.EmailAddress,
        "PortalType": "Partner",
        "ReferenceID": `E-${loginData.EIN}`,
        "PortalUserID": loginData.PortalUserID
      }
    }
    if (signInfo.esign.value != "" && signInfo.esign.isValid) {
      setIsLoader(true)
        dispatch(submitClaim({ prgData: claimProcessData.Program, reqBody }))
    } else {
      toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
      setSignInfo((prevState) => ({
        ...prevState,
        esign: {
          value: prevState.esign.value,
          isValid: prevState.esign.isValid && prevState.esign.value != '',
        },
      }))
    }
    return true
  }

  contT.formValidation.isValidate = onSubmitClaim;
  return (
    <div className="container pt-5">
      {isLoader && <Loader />}
      <p className="fw-bolder text-start p-8">
        I attest that the information supplied is complete, accurate and supported in the patient’s medical records. I understand this information is for the sole use of the Patient Advocate Foundation TotalAssist Program, its representatives, and/or agents selected in order to assess the patient’s eligibility for participation in the program. I understand that the assistance is temporary, and the patient may be asked to reapply at designated intervals.
      </p>
      <p className="fw-bolder text-start fs-lg px-8">Electronic Signature:</p>
      <p className="mt-5 text-start px-8">I hereby certify that the foregoing statements, including any accompanying statements and/or documents submitted are true, complete and accurate to the best of my knowledge. Please enter a value in the field below that represents you signing this document.</p>
      <br />
      <div className="grid columns-12 gap-4 gap-y-5">
        <Input
          type="text"
          id="esign"
          label={selectedLanguage.esign}
          name="esign"
          value={signInfo.esign.value}
          isValid={signInfo.esign.isValid}
          onChange={(e) => inputOnChange(e, "name")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
        />
      </div>
    </div>
  );
}

export default Signature;
